import { render, staticRenderFns } from "./BreakdownList.vue?vue&type=template&id=3ed12ac8&scoped=true&"
import script from "./BreakdownList.vue?vue&type=script&lang=js&"
export * from "./BreakdownList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed12ac8",
  null
  
)

export default component.exports